import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
// utils
import { fToNow } from 'src/utils/format-time';
// components
import Label from 'src/components/label';
import { GrUpdate } from "react-icons/gr";
import { MdUpdate } from "react-icons/md";
import FileThumbnail from 'src/components/file-thumbnail';

import {
  AiOutlineCloseCircle,     // High
  AiOutlineExclamationCircle, // Medium
  AiOutlineCheckCircle,     // Low
  AiOutlineInfoCircle,      // Info
  AiOutlineBell,            // Reminder
} from 'react-icons/ai';
import { TbInfoTriangle } from "react-icons/tb";
import { ListItem } from '@mui/material';
import noDataImage from '../../../defaultimg/Bell.png';


// ----------------------------------------------------------------------

const NoDataComponent = () => (
  <div style={{ textAlign: 'center', padding: '16px', backgroundColor: 'transparent' }}>
    <img src={noDataImage} alt="No Data Found" style={{ maxWidth: '100%', height: '100px' }} />
    <Typography variant="h6" color="text.secondary" sx={{ mt: 1 }}>
      No Notifications Found
    </Typography>
  </div>
);

export default function NotificationItem({ notification, onClick}) {

  
  // const renderAvatar = (
  //   <ListItemAvatar>
  //     {notification.avatarUrl ? (
  //       <Avatar src={notification.avatarUrl} sx={{ bgcolor: 'background.neutral' }} />
  //     ) : (
  //       <Stack
  //         alignItems="center"
  //         justifyContent="center"
  //         sx={{
  //           width: 40,
  //           height: 40,
  //           borderRadius: '50%',
  //           bgcolor: 'background.neutral',
  //         }}
  //       >
  //         <Box
  //           component="img"
  //           src={`/assets/icons/notification/${
  //             (notification.type === 'order' && 'ic_order') ||
  //             (notification.type === 'chat' && 'ic_chat') ||
  //             (notification.type === 'mail' && 'ic_mail') ||
  //             (notification.type === 'delivery' && 'ic_delivery')
  //           }.svg`}
  //           sx={{ width: 24, height: 24 }}
  //         />
  //       </Stack>
  //     )}
  //   </ListItemAvatar>
  // );

  // const priorityColors = {
  //   High: 'error.lighter',
  //   Medium: 'warning.lighter',
  //   Low: 'success.lighter',
  // };

  const priorityMap = {
    alert: {
     
      icon: TbInfoTriangle,
      color: '#f73105', 
    },
    notice: {
      icon: AiOutlineExclamationCircle,
      color: '#eda105', 
    },
    Low: {
      icon: AiOutlineCheckCircle,
      color: '#2E7D32', 
    },
    important: {
      icon: AiOutlineInfoCircle,
      color: '#00B8D9',  
    },
    update: {
      icon: MdUpdate,
      color: '#02c249', 
    },
  };
  
  const current = priorityMap[notification.priority] || priorityMap.Low;
  const IconComponent = current.icon;
  const iconColor = current.color;
  
  let bgColor = 'success.lighter';

  if (notification.priority === 'High') {
    bgColor = 'error.lighter';
  } else if (notification.priority === 'Medium') {
    bgColor = 'warning.lighter';
  }
  const renderText = (
    
<ListItem
button onClick={onClick}
sx={{
  px: 1.5,
  py: 1,
  alignItems: 'flex-start',
  borderLeft: `5px solid ${iconColor}`,
  mb: 1,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  borderRadius: 1,
  // bgcolor: 'background.paper',
}}
>
  <Box sx={{ mr: 2, mt: 0.5 }}>
    <IconComponent size={32} color={iconColor} />
  </Box>

  <ListItemText
    disableTypography
    primary={
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
        {reader(notification.description)}
      </Typography>
    }
    secondary={
      <Stack
        direction="row"
        alignItems="center"
        sx={{ typography: 'caption', color: 'text.disabled', mt: 0.5 }}
        divider={
          <Box
            sx={{
              width: 4,
              height: 4,
              bgcolor: iconColor,
              ml:3,
              mr:0.5,
              borderRadius: '50%',
            }}
          />
        }
      >
        {fToNow(notification.createdAt)}

        <Box
          component="span"
          sx={{
            color: iconColor,
            fontWeight: 600,
            textTransform: 'uppercase',
            ml: 0,
          }}
        >
          {notification.priority}
        </Box>
      </Stack>
    }
  />
</ListItem>


  );

  const renderUnReadBadge = notification.isUnRead && (
    <Box
      sx={{
        top: 26,
        width: 8,
        height: 8,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'info.main',
        position: 'absolute',
      }}
    />
  );

  // const friendAction = (
  //   <Stack spacing={1} direction="row" sx={{ mt: 1.5 }}>
  //     <Button size="small" variant="contained">
  //       Accept
  //     </Button>
  //     <Button size="small" variant="outlined">
  //       Decline
  //     </Button>
  //   </Stack>
  // );

  const projectAction = (
    <Stack alignItems="flex-start">
      <Box
        sx={{
          p: 1.5,
          my: 1.5,
          borderRadius: 1.5,
          color: 'text.secondary',
          bgcolor: 'background.neutral',
        }}
      >
        {reader(
          `<p><strong>@Jaydon Frankie</strong> feedback by asking questions or just leave a note of appreciation.</p>`
        )}
      </Box>

      <Button size="small" variant="contained">
        Reply
      </Button>
    </Stack>
  );


  return (
    <ListItemButton
      disableRipple
      sx={{
        pl:2,
        pr:2,
        alignItems: 'flex-start',
        // borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
      }}
    >
      {/* {renderUnReadBadge} */}

      {/* {renderAvatar} */}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}
       
      </Stack>
    </ListItemButton>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.object,
  onClick: PropTypes.func,
};

// ----------------------------------------------------------------------

function reader(data) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        mb: 0.5,
        '& p': { typography: 'body2', m: 0 },
        '& a': { color: 'inherit', textDecoration: 'none' },
        '& strong': { typography: 'subtitle2' },
      }}
    />
  );
}
